import { convertToDatum } from '../../../Util';
import { TimeSeries, IndexDatum } from '../';

const d3 = require('d3');


/**
 * 
 */
export class IndexSeries extends TimeSeries {
  /**
   * Initialize a IndexSeries from an input Array
   * 
   * @param {Array} input Array of Datum or Datum-compatible value pairs
   */
  constructor(input) {
    super();
    this.createObserver(); // Hack to avoid Vue destroying the class
    
    // Handle empty initialization
    let inputArray = input ?? [];
    this.push(...inputArray);
  }


  /**
   * Push Datum-compatible elements into the series
   * 
   * @param  {...any} inputArray List of items to add to the series
   */
  push(...inputArray) {
    for (let i of inputArray) {
      let datum = convertToDatum(i);

      if (datum instanceof IndexDatum) {
        super.push(datum);
      } else {
        throw Error('Datum must be of Index type');
      }
    }
  }


  /**
   * Extend the series up to a given index
   * 
   * @param {Number} extensionIndex New index to extend the series up to (inclusive)
   */
  extendSeries(extensionIndex) {
    let lastIndex = d3.max(this.getIndices());

    for (let i = lastIndex+1; i <= extensionIndex; i++) {
      this.push([i, null]);
    }
  }
}